import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import PageHeader from "../../components/common/PageHeader";
import HsCodesPanel from "../../components/codes/HsCodesPanel";
import useUrlState from "../../hooks/useUrlState";
import { slugifyTab } from "../../utils/tabSlug";

// Add future code-type tabs here — e.g. { label: "Vessel Codes", component: VesselCodesPanel }
const CODE_TABS = [
    { label: "HS Codes", component: HsCodesPanel },
];

// Module-level (not inline in the component) so useUrlState gets a stable
// reference every render — see that hook's own doc comment for why.
const URL_SCHEMA = {
    tab: { default: "" },
};

const AdminCodes = () => {
    const [urlState, setUrlState] = useUrlState(URL_SCHEMA);
    const tab = Math.max(0, CODE_TABS.findIndex((t) => slugifyTab(t.label) === urlState.tab));
    const ActivePanel = CODE_TABS[tab].component;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <PageHeader
                title="Codes"
                subtitle="Manage reference code lists used across shipments and customs declarations"
            />

            <Tabs
                value={tab}
                onChange={(_, v) => setUrlState({ tab: slugifyTab(CODE_TABS[v].label) })}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    "& .MuiTab-root": {
                        fontSize: 13,
                        textTransform: "none",
                        fontWeight: 600,
                        minHeight: 44,
                    },
                }}
            >
                {CODE_TABS.map((t) => (
                    <Tab key={t.label} label={t.label} />
                ))}
            </Tabs>

            <ActivePanel />
        </Box>
    );
};

export default AdminCodes;